import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-160da24e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "citation flex flex-no-wrap text-2xl" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "„", -1))
const _hoisted_3 = { class: "my-auto mx-md" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "“", -1))
const _hoisted_5 = { class: "flex mt-lg mx-auto" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "my-auto font-bold text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col max-w-body-width mx-auto", [_ctx.__elementspacingclass]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("p", _hoisted_3, _toDisplayString($props.text), 1),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      ($props.media)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "w-citation-image mr-md rounded-full-i",
            src: $props.media,
            alt: `Bild von ${$props.person}`
          }, null, 8, _hoisted_6))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_7, _toDisplayString($props.person), 1)
    ])
  ], 2))
}